import { gql } from '@apollo/client';
import client from 'apollo/apollo-client';

const MUTATION_RESETPASSWORD = gql`
  mutation resetPassword($email: String!) {
    resetPassword(email: $email) {
      error
      data {
        _id
        name
        email
        roles
        language
        active
      }
      message
    }
  }
`;

export async function resetPassword(email) {
  return await new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: MUTATION_RESETPASSWORD,
        variables: { email },
      })
      .then(
        ({
          data: {
            resetPassword: { error, data, message },
          },
          loading,
        }) => {
          resolve({ data, loading, error, message });
        },
      )
      .catch((error) => {
        reject(new Error({ error: true, message: error.message, data: {} }));
      });
  });
}
